import { useEffect, useState } from 'react';
export function useIsTouchDevice() {
    const [isTouchDevice, setIsTouchDevice] = useState(false);
    useEffect(() => {
        const isTouchDevice = window.matchMedia('(pointer: coarse)');
        const updateStatus = () => setIsTouchDevice(isTouchDevice.matches);
        isTouchDevice.addEventListener('change', updateStatus);
        updateStatus();
        return () => isTouchDevice.removeEventListener('change', updateStatus);
    }, []);
    return isTouchDevice;
}
